import React from 'react';
import {Button} from "react-bootstrap";

const Row = ({ id, day, affid, subid, onRemove }) => {
    return (
        <tr>
            <td>{day}</td>
            <td>{affid}</td>
            <td>{subid}</td>
            <td><Button bsStyle="danger" onClick={() => onRemove(id)}>Remove</Button></td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiBlock/components/Table/components/Row/index.js